import { invoiceStateColors, invoiceStateLabels } from '@/constants'
import { InvoiceState } from '@/types'
import { Badge, BadgeProps } from '@mantine/core'

export default function InvoiceStateBadge({ state, size }: { state: InvoiceState; size?: BadgeProps['size'] }) {
  return (
    <Badge variant="light" color={invoiceStateColors[state]} size={size} style={{ flexShrink: 0, overflow: 'visible' }}>
      {invoiceStateLabels[state]}
    </Badge>
  )
}
